import {
  createTheme,
  makeStyles,
  responsiveFontSizes,
} from "@material-ui/core/styles"
import { alpha } from "@material-ui/core/styles/colorManipulator"

const theme = responsiveFontSizes(
  createTheme({
    palette: {
      primary: {
        main: "#031037",
        contrastText: "#FFFFFF",
      },
      secondary: {
        main: "#FFFFFF",
        contrastText: "#031037",
      },
    },
    typography: {
      fontFamily: "RoobertVRT, sans-serif",
      h2: {
        fontWeight: "bold",
      },
      h3: {
        color: "#031037",
        fontWeight: "bold",
      },
    },
    overrides: {
      MuiCssBaseline: {
        "@global": {
          body: {
            backgroundColor: "#FFF",
            textAlign: "center",
            color: "#031037",
          },
          section: {
            minHeight: "100vh",
            padding: "20px",
            "&.inverted": {
              backgroundColor: "#031037",
              color: "white",
            },
          },
        },
      },
      MuiTextField: {
        root: {
          backgroundColor: "#FFF",
          marginTop: "30px",
          borderTopLeftRadius: "10px",
          borderTopRightRadius: "10px",
        },
      },
      MuiFilledInput: {
        root: {
          backgroundColor: "white",
          borderTopLeftRadius: "10px",
          borderTopRightRadius: "10px",
        },
        underline: {
          borderBottomColor: "red",
        },
      },
      MuiButton: {
        root: {
          borderRadius: "10px",
          marginTop: "20px",
        },
        containedSecondary: {
          "&:hover": {
            backgroundColor: alpha("#808080", 0.7),
            color: "white",
          },
        },
      },
    },
    spacing: 2,
  })
)

export const useInvertedStyles = makeStyles(theme => ({
  containedPrimary: {
    backgroundColor: theme.palette.primary.contrastText,
    color: theme.palette.primary.main,
    "&:hover": {
      backgroundColor: alpha(theme.palette.primary.main, 0.3),
    },
  },
}))

export default theme
